import IProfileData from '@profile/pages/AccountPage/IProfileData';
import { IProfileDataUpdate, IState, TProfileData } from '@profile/pages/AccountPage/features/profileAccountHook';

export const setProfileDataAfterEmailUpdate = (profileData: IProfileData | null, email: string): IProfileData | null => {
  return profileData ? {
    ...profileData ,
    verification: {
      ...profileData!.verification,
      email,
    },
  } : profileData;
};

export const updateProfileDataTransformator = (state: IState, actionData: IProfileDataUpdate): IState => {
  if (!state.profileDataUpdate) {
    return state;
  }

  const updatedProfileData = {
    ...state.profileDataUpdate,
    [actionData.path[0]]: {
      ...state.profileDataUpdate[actionData.path[0] as TProfileData],
      [actionData.path[1]]: actionData.value,
    },
  };

  return {
    ...state,
    profileDataUpdate: updatedProfileData,
    isInitialize: true,
  };
};
